// extracted by mini-css-extract-plugin
export var footer = "_jp-0";
export var inherit = "_jp-1";
export var input = "_jp-2";
export var modalContent = "_jp-3";
export var quillEditor = "_jp-4";
export var subtitle = "_jp-5";